export function focusTarget(target: HTMLElement) {
  target.setAttribute('tabindex', '-1');
  target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
  target.focus({ preventScroll: true });
}
